import PropTypes from 'prop-types';
import React from 'react';
import envConfig from 'trade-in/config/index.js';
import CBBAutoComplete from 'trade-in/components/CBBAutoComplete/CBBAutoComplete.jsx';
import { ContentZonesService } from '@sm360/widget-commons-core-services';

const NewInstantEstimateAutocomplete = ({ onAutoCompleteSelect, selectedValue, parentClassName, config }) => {
    const czGroup = 'widget.tradein.teaser';

    const mainImage = ContentZonesService.getContentZone(czGroup, 'appraisal.main.image')
        ? ContentZonesService.getContentZone(czGroup, 'appraisal.main.image').getValue()
        : undefined;

    const imagesServer = envConfig.source.image;
    return (
        <div className="instant-estimate__content">
            <div className="instant-estimate__text-content">
                {mainImage && <img src={mainImage} alt="main-tradein__image" className="main-tradein__image" />}
                <img
                    src={`${imagesServer}/images/widget/showroom/asset/canadian_black_book_monochrone.png`}
                    alt="teaser-cbb__image"
                    className="teaser-cbb__image"
                />
                <CBBAutoComplete
                    onValueSelected={onAutoCompleteSelect}
                    value={selectedValue}
                    dataTestPrefix="trade-in.instant-estimate-autocomplete"
                    parentClassName={parentClassName}
                    config={config}
                />
            </div>
        </div>
    );
};

NewInstantEstimateAutocomplete.defaultProps = {
    config: {},
};

NewInstantEstimateAutocomplete.propTypes = {
    onAutoCompleteSelect: PropTypes.func.isRequired,
    selectedValue: PropTypes.string.isRequired,
    parentClassName: PropTypes.string.isRequired,
    config: PropTypes.object,
};

NewInstantEstimateAutocomplete.displayName = 'NewInstantEstimateAutocomplete';

export default NewInstantEstimateAutocomplete;
